<template>
  <div class="my-upload">
    <input
      type="file"
      ref="upload"
      :accept="fileType ? `${fileType}/${fileType.split('/')[1] || '*'}` : ''"
      @change="uploadChange"
      :multiple="multiple && limit && limit > 1"
      style="display: none"
    />
    <ul class="file-list" ref="list">
      <template v-for="(item, index) in uploadList" :key="item.name || item.id">
        <li :style="size ? { width: `${size}px`, height: `${size}px` } : {}">
          <img
            :src="item.url"
            v-if="item.url && item.type !== 'video'"
            alt="加载失败"
          />
          <video
            :src="item.url"
            v-if="item.url && item.type === 'video'"
            autoplay
            muted
          ></video>
          <span v-if="!item.url" class="arg-err">数据参数<br />格式错误</span>
          <div class="file-options" v-if="item.url">
            <div class="drag-block" v-if="sort && uploadList.length > 1">
              <div class="arrow">
                <i
                  v-if="index > 0"
                  class="el-icon-arrow-left"
                  title="前移"
                  @click="handleMove(index, 'prev')"
                ></i>
              </div>
              <div class="arrow">
                <i
                  v-if="index < uploadList.length - 1"
                  class="el-icon-arrow-right"
                  title="后移"
                  @click="handleMove(index, 'next')"
                ></i>
              </div>
            </div>
            <i
              class="file-option el-icon-zoom-in"
              title="预览"
              @click="previewInfo = item"
            ></i>
            <i
              v-if="showUpdate"
              @click="
                updateIndex = index;
                $refs['upload'].click();
              "
              class="file-option el-icon-edit-outline"
              title="修改"
            ></i>
            <i
              v-if="showDelete"
              class="file-option el-icon-delete"
              title="删除"
              @click="handleRemove(index)"
            ></i>
          </div>
        </li>
        <li
          class="block"
          v-if="rowLength > 0 && index > 0 && (index + 1) % rowLength === 0"
        ></li>
      </template>
      <li
        class="upload-card"
        :style="size ? { width: `${size}px`, height: `${size}px` } : {}"
        @click="$refs['upload'].click()"
        v-if="!limit || (limit && uploadList.length < limit)"
      >
        <div class="upload-cover">
          <slot name="icon"></slot>
          <slot name="title"></slot>
          <slot name="desc"></slot>
        </div>
      </li>
    </ul>
    <preview
      :show="Object.keys(previewInfo).length"
      :info="previewInfo"
      @close="previewInfo = {}"
    />
  </div>
</template>

<script>
import Preview from "./Preview/Preview";

/* eslint-disable */
export default {
  name: "MyUpload",

  components: {
    Preview,
  },

  props: {
    size: {
      type: Number,
      default: () => null,
    },
    // 是否多选 默认否
    multiple: {
      type: Boolean,
      default: () => false,
    },
    // 文件列表
    fileList: {
      type: Array,
      default: () => [],
    },
    // 上限
    limit: {
      type: Number,
      default: () => null,
    },
    // 是否排序
    sort: {
      type: Boolean,
      default: () => false,
    },
    // 是否预览 默认是
    showPreview: {
      type: Boolean,
      default: () => true,
    },
    // 是否可修改 默认否
    showUpdate: {
      type: Boolean,
      default: () => false,
    },
    // 是否可删除 默认否
    showDelete: {
      type: Boolean,
      default: () => false,
    },
    // 图片大小限制 0为不限制
    imageSize: {
      type: Number,
      default: () => 0,
    },
    // 视频大小限制 0为不限制
    videoSize: {
      type: Number,
      default: () => 0,
    },
    // 文件类型限制 ""为不限制
    fileType: {
      type: String,
      default: () => "",
    },
    rowLength: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      uploadList: [],
      previewInfo: {},
      updateIndex: -1,
    };
  },

  watch: {
    fileList: {
      handler(arr) {
        this.uploadList = [...arr];
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    // 文件域 change 触发
    async uploadChange(e) {
      const postFiles = Array.from(e.target.files);
      if (!postFiles.length) return false;
      let filesLen = postFiles.length;

      // 判断是否有类型限制
      if (this.fileType) {
        if (this.fileType.split("/")[0] === "image") {
          let imageHasOtherType =
            postFiles.filter((i) => i.type.split("/")[0] !== "image").length >
            0;
          if (imageHasOtherType) {
            this.$message.warning(`上传类型仅为图片`);
            return false;
          }
          if (this.fileType.split("/")[1]) {
            imageHasOtherType =
              postFiles.filter(
                (i) => i.type.split("/")[1] !== this.fileType.split("/")[1]
              ).length > 0;
            if (imageHasOtherType) {
              this.$message.warning(
                `上传类型仅为 ${this.fileType.split("/")[1]} 格式的图片`
              );
              return false;
            }
          }
        }
        if (this.fileType.split("/")[0] === "video") {
          let videoHasOtherType =
            postFiles.filter((i) => i.type.split("/")[0] !== "video").length >
            0;
          if (videoHasOtherType) {
            this.$message.warning(`上传类型仅为视频`);
            return false;
          }
        }
      }

      // 判断是否超出上传数量上限
      if (
        this.updateIndex === -1 &&
        this.limit &&
        this.limit < filesLen + this.uploadList.length
      ) {
        this.$refs["upload"].value = "";
        this.$message.warning(`可上传数量上限为 ${this.limit} 张`);
        return false;
      }

      // 判断是否有图片超出大小限制
      let imgHasOverSize =
        postFiles.filter(
          (i) =>
            i.type.split("/")[0] === "image" && this.imageSize < i.size / 1024
        ).length > 0;
      if (this.imageSize > 0 && imgHasOverSize) {
        this.$message.warning(
          `图片大小限制在 ${this.imageSize}KB (${this.imageSize / 1024}MB) 内`
        );
        this.$refs["upload"].value = "";
        return false;
      }

      // 判断是否有视频超出大小限制
      let videoHasOverSize =
        postFiles.filter(
          (i) =>
            i.type.split("/")[0] === "video" && this.videoSize < i.size / 1024
        ).length > 0;
      if (this.videoSize > 0 && videoHasOverSize) {
        this.$message.warning(
          `视频大小限制在 ${this.videoSize}KB (${this.videoSize / 1024}MB) 内`
        );
        this.$refs["upload"].value = "";
        return false;
      }
      for (let i = 0; i < filesLen; i++) {
        let url, type;
        if (postFiles[i].type.split("/")[0] === "video") {
          url = this.getObjectURL(postFiles[i]);
          type = "video";
        } else {
          url = await this.fileToBase64(postFiles[i]);
        }
        let dealFile = {
          name: postFiles[i].name,
          url,
          type,
          file: postFiles[i],
        };
        if (postFiles[i].type.split("/")[0] === "video")
          dealFile.type = "video";
        this.updateIndex === -1 && this.uploadList.push(dealFile);
        this.updateIndex >= 0 &&
          this.uploadList.splice(this.updateIndex, 1, {
            ...dealFile,
            id: this.uploadList[this.updateIndex].id,
          });
      }
      this.updateIndex = -1;

      this.$emit("onChange", [...this.uploadList]);
      this.$refs["upload"].value = "";
    },

    /**
     * 预览图片
     * @param file 上传的 file 文件
     * @returns String<Promise> base64
     */
    fileToBase64(file) {
      return new Promise((resolve) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = function () {
          resolve(this.result);
        };
      });
    },

    /**
     * 预览视频
     * @param file 上传的 file 文件
     * @returns {null} 视频地址 blob://***
     */
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },

    handleMove(index, type) {
      if (type === "prev") {
        this.uploadList.splice(
          index - 1,
          0,
          this.uploadList.splice(index, 1)[0]
        );
      } else if (type === "next") {
        this.uploadList.splice(
          index + 1,
          0,
          this.uploadList.splice(index, 1)[0]
        );
      }
      this.$emit("onChange", [...this.uploadList]);
    },

    /**
     * 触发移除 $emit -> on-remove
     * 页面调用删除成功后 watch 的 fileList 会覆盖组件内的 updateList
     * @param index 文件下标
     */
    handleRemove(index) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("onRemove", index);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "MyUpload";
</style>
